import { Component, Output, EventEmitter } from '@angular/core';
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {LocalStorageService} from "library";
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {environment} from "projects/store/src/environments/environment";

@Component({
  selector: 'app-header',
  templateUrl: './app.header.component.html'
})
export class AppHeaderComponent {
  userData: UserData;
  srcLogo = `assets/images/${environment.global.country.code}/krediya-logo.png`;
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor(
    private localStorageService: LocalStorageService, 
    private authService: AuthService
  ) {
    this.userData = this.localStorageService.get(LocalStorageKey.data)
  }

  gotoSalesModule(link: string) {
    if(link == 'logout') {
      this.authService.gotoSalesModule('auth/logout')
    }
  }

  sidebarToggle() {
    this.toggleSidebar.emit();
  }
}
